import React from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";

const SelectSegmento = ({
  register,
  segmento,
  setSegmento,
  setFormData,
  outroSegmento,
  setOutroSegmento
}) => {
  return (
    <Box display="flex" flexDirection="column" alignContent="center" alignItems="center" width="100%" mb={2}>
      <Box width="100%" maxWidth="400px">
        <h1 style={{ textAlign: "center" }}>Selecione seu segmento:</h1>
        <Box>
          <FormControl fullWidth>
            <InputLabel id="segmento-label">Selecione seu segmento aqui</InputLabel>
            <Select 
              {...register('Segmento', { required: true })} 
              label="Segmento" 
              onChange={(e) => {
                const val = e.target.value;
                setFormData(prevState => ({ 
                  ...prevState, 
                  Segmento: val === "Outros" ? `Outros ${outroSegmento || ''}`.trim() : val 
                }));
                setSegmento(val);
              }} 
              value={segmento || ''}
            >
              <MenuItem value="Doceria">Doceria</MenuItem>
              <MenuItem value="Drinks">Drinks</MenuItem>
              <MenuItem value="Restaurante/Delivery">Restaurante/Delivery</MenuItem>
              <MenuItem value="Milk Shake">Milk Shake</MenuItem>
              <MenuItem value="Padaria">Padaria</MenuItem>
              <MenuItem value="Clínica">Clínica</MenuItem>
              <MenuItem value="Cafeteria">Cafeteria</MenuItem>
              <MenuItem value="Escritório">Escritório</MenuItem>
              <MenuItem value="Açai">Açai</MenuItem>
              <MenuItem value="Sorveteria">Sorveteria</MenuItem>
              <MenuItem value="Natal">Natal</MenuItem>
              <MenuItem value="Copa">Copa</MenuItem>
              <MenuItem value="Outros">Outros</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Box>

      {segmento === "Outros" && (
        <Box alignItems="center" width="100%" maxWidth="400px" mt={2}>
          <TextField
            fullWidth
            placeholder="Especifique o segmento"
            value={outroSegmento || ''}
            onChange={(e) => {
              const val = e.target.value;
              setFormData(prevState => ({ ...prevState, Segmento: `Outros ${val}` }));
              setOutroSegmento(val);
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default SelectSegmento;
